<script>
import { mapGetters } from 'vuex'
import { API_ROOT } from '../api/config'

export default {
  computed: {
    ...mapGetters([
      'user',
      'userSetting'
    ]),
    avatarUrl () {
      let avatar = this.avatar || ((this.userSetting || {}).avatar_file || {})
      if (avatar.id || avatar.url) {
        let config = this.$ls.get('userInfo')
        return avatar.url || (API_ROOT + 'global/files/download?file_id=' + avatar.id + '&class_name=' + avatar.class_name + '&access_token=' + config['access_token'])
      } else {
        return require('../assets/images/user-avatar.svg')
      }
    }
  },
  methods: {
    rolePermission (roles) {
      return roles.includes((this.user || {}).role)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/userPermission.vue